<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-06-21 14:54:00
 * @LastEditTime: 2022-09-24 15:16:44
 * @LastEditors: mdb
-->
<template>
  <div class="header-title-content">
    <span class="header-title-content_line"></span>
    <p class="header-title-content_title">{{ props.title }}</p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>
<script lang="ts">
export default { name: 'HeaderTitle' }
</script>

<style lang="scss" scoped>
.header-title-content {
  display: flex;
  align-items: center;
  height: 24px;
  margin-bottom: 13px;
  line-height: 1;
  .header-title-content_line {
    width: 4px;
    height: 14px;
    margin-right: 4px;
    border-radius: 2px;
    background: $Primary;
  }
  .header-title-content_title {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
